
import './App.css';
import Countriesapi from './components/CountriesApi/Countriesapi';
// import { useEffect, useState } from 'react';
/*
import './components/Headers/Header.css'
import Header from './components/Headers/Header';
import Country from './components/Countries/Country';
import Person from './components/Persons/Person' */;


function App() {
  return (
    <div className="App">
    <Countriesapi></Countriesapi>


    {/* <Header></Header>
    <Country></Country>
    <Person></Person> */}
  
    {/*  <LoadCountries></LoadCountries>
    <Country>0</Country> */}
    </div>
  );
}

/* function LoadCountries(props){
  const [countries,setContrites] = useState([])
  useEffect(()=>{
    fetch('https://restcountries.com/v3.1/all')
    .then(res => res.json())
    .then(data => setContrites(data))
  },[])

  return(
    <div>
      <h1>Get Rest Countries</h1>
      <h3>Available Counties : {countries.length}</h3>
      {
        countries.map(country => <Country name = {country.name.common}></Country> )
      }
    </div>
  )
}

function Country(props){
  return(
    <div>
      <h2>Name : {props.name}</h2>
    </div>
  )
}

 */
export default App;
